import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-77b918ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "wrap grid" }
const _hoisted_3 = { class: "brand" }
const _hoisted_4 = { class: "tagline" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "heading" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "heading" }
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = { class: "heading" }
const _hoisted_12 = { class: "wrap bottom" }

import { company } from "../company";
import MadarionLogo from "./MadarionLogo.vue";
import ConnecteraLogo from "./ConnecteraLogo.vue";
import { useLocalePath } from "../composables/useLocalePath";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

const lp = useLocalePath();
const year = new Date().getFullYear();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(MadarionLogo),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("footer.tagline")), 1),
        _createElementVNode("a", {
          href: `mailto:${_unref(company).email}`,
          class: "mail"
        }, _toDisplayString(_unref(company).email), 9, _hoisted_5)
      ]),
      _createElementVNode("nav", {
        "aria-label": _ctx.$t('footer.services')
      }, [
        _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t("footer.services")), 1),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: { path: _unref(lp)('/'), hash: '#services' },
              class: "link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("footer.app_dev")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: { path: _unref(lp)('/'), hash: '#services' },
              class: "link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("footer.cloud")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: { path: _unref(lp)('/'), hash: '#services' },
              class: "link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("footer.gateway")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: { path: _unref(lp)('/'), hash: '#ai' },
              class: "link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("footer.ai")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ], 8, _hoisted_6),
      _createElementVNode("nav", {
        "aria-label": _ctx.$t('footer.company')
      }, [
        _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t("footer.company")), 1),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: _unref(lp)('/about'),
              class: "link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("footer.about")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: _unref(lp)('/connectera'),
              class: "link product"
            }, {
              default: _withCtx(() => [
                _createVNode(ConnecteraLogo, { class: "mini" })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: _unref(lp)('/security'),
              class: "link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("footer.security")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: _unref(lp)('/contact'),
              class: "link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("footer.contact")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ], 8, _hoisted_8),
      _createElementVNode("nav", {
        "aria-label": _ctx.$t('footer.legal')
      }, [
        _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$t("footer.legal")), 1),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: _unref(lp)('/legal-notice'),
              class: "link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("footer.legal_notice")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: _unref(lp)('/privacy'),
              class: "link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("footer.privacy")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ], 8, _hoisted_10)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("span", null, "© " + _toDisplayString(_unref(year)) + " " + _toDisplayString(_unref(company).legalName) + ". " + _toDisplayString(_ctx.$t("footer.rights")), 1)
    ])
  ]))
}
}

})